export const designs = [
  {
    image: require('../images/sniwwoc/img01.png'),
    name: "design01"
  },
  {
    image: require('../images/sniwwoc/img02.png'),
    name: "design02"
  },
  {
    image: require('../images/sniwwoc/img03.png'),
    name: "design03"
  },
  {
    image: require('../images/sniwwoc/img04.png'),
    name: "design04"
  },
  {
    image: require('../images/sniwwoc/img05.png'),
    name: "design05"
  },
  {
    image: require('../images/sniwwoc/img06.png'),
    name: "design06"
  },
  {
    image: require('../images/sniwwoc/img07.png'),
    name: "design07"
  }
]